import { render } from "./ListSongs.vue?vue&type=template&id=773c855c&scoped=true"
import script from "./ListSongs.vue?vue&type=script&lang=js"
export * from "./ListSongs.vue?vue&type=script&lang=js"

import "./ListSongs.vue?vue&type=style&index=0&id=773c855c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kedaq\\Desktop\\pruebaBodyTech\\pruebaspotify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773c855c"]])

export default __exports__